import { defineCustomElement } from 'vue'
import { i18n } from 'i18n'
import { VolverPlugin } from '@volverjs/ui-vue'
import { normal } from '@volverjs/ui-vue/icons'
import custom from 'icons'

// Import the Vue component.
import FloatingChatWidget from '~/components/FloatingChatWidget.ce.vue'

// Turn the Vue component into a Custom Element class.
export const FloatingChatWidgetCe = defineCustomElement(FloatingChatWidget, {
    configureApp(app) {
        app.use(i18n)
        app.use(VolverPlugin, {
            iconsCollections: [normal, custom],
        })
    },
})

// Remember to register the element class with the browser.
customElements.define('floating-chat-widget', FloatingChatWidgetCe)

// Add the new element type to Vue's GlobalComponents type.
declare module 'vue' {
    interface GlobalComponents {
        // Be sure to pass in the Vue component type here
        // (SomeComponent, *not* SomeElement).
        // Custom Elements require a hyphen in their name,
        // so use the hyphenated element name here.
        'floating-chat-widget': typeof FloatingChatWidget
    }
}
